webpackJsonp([212839066777427],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  * {\n    line-height: 20px;\n    margin: 0;\n  }\n  h2 {\n    margin-right: 1rem;\n    margin-bottom: 0 !important;\n  }\n  .inner-wrapper {\n    justify-content: center;\n    align-items: center;\n    margin: auto auto;\n    // max-width: 800px;\n\n    @media screen and (max-width: 460px) {\n      display: block !important;\n    }\n  }\n'], ['\n  * {\n    line-height: 20px;\n    margin: 0;\n  }\n  h2 {\n    margin-right: 1rem;\n    margin-bottom: 0 !important;\n  }\n  .inner-wrapper {\n    justify-content: center;\n    align-items: center;\n    margin: auto auto;\n    // max-width: 800px;\n\n    @media screen and (max-width: 460px) {\n      display: block !important;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Styles = _styledComponents2.default.div(_templateObject);
	
	var BlogHeader = function BlogHeader() {
	  return _react2.default.createElement(
	    Styles,
	    { className: 'section is-flex has-background-dark' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns is-desktop inner-wrapper is-flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title has-text-white has-text-right has-text-left-mobile is-uppercase is-size-1' },
	            'Blog'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-three-quarters' },
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-white has-text-left is-size-5 has-text-weight-semibold' },
	            'These are the words and paragraphs we use to communicate ideas that travel beyond your screen.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlogHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogListQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  .featured-article {\n    margin: 4rem 0;\n\n    @media screen and (max-width: 768px) {\n      display: flex;\n      flex-direction: column;\n\n      .featured-content {\n        order: 2;\n        flex-basis: unset;\n      }\n    }\n  }\n  .featured-content {\n    padding: 3rem;\n    flex-direction: column;\n    justify-content: center;\n\n    @media screen and (max-width: 768px) {\n      padding: 1rem;\n    }\n  }\n\n  .divider {\n    max-width: 1200px;\n    margin: auto auto;\n  }\n\n  .list-article {\n    @media screen and (max-width: 768px) {\n      margin: 2rem 0;\n    }\n  }\n'], ['\n  .featured-article {\n    margin: 4rem 0;\n\n    @media screen and (max-width: 768px) {\n      display: flex;\n      flex-direction: column;\n\n      .featured-content {\n        order: 2;\n        flex-basis: unset;\n      }\n    }\n  }\n  .featured-content {\n    padding: 3rem;\n    flex-direction: column;\n    justify-content: center;\n\n    @media screen and (max-width: 768px) {\n      padding: 1rem;\n    }\n  }\n\n  .divider {\n    max-width: 1200px;\n    margin: auto auto;\n  }\n\n  .list-article {\n    @media screen and (max-width: 768px) {\n      margin: 2rem 0;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(11);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _header = __webpack_require__(102);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _Slide = __webpack_require__(49);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _gatsbySourceDatocms = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PageWrapper = _styledComponents2.default.div(_templateObject);
	
	var Blog = function Blog(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, { seo: data.datoCmsBlogPage.seoMetaTags }),
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      'article',
	      { className: 'featured-article columns' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column is-hidden-tablet' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'title has-text-dark ' },
	          'Featured'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'featured-content is-flex column is-half' },
	        _react2.default.createElement(
	          'p',
	          { className: 'has-text-primary' },
	          data.datoCmsBlogPage.featured.publishDate
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' + data.datoCmsBlogPage.featured.slug, className: '' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title is-marginless is-size-3 has-text-dark is-uppercase has-text-weight-bold' },
	            data.datoCmsBlogPage.featured.title
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'has-text-dark' },
	          data.datoCmsBlogPage.featured.excerpt,
	          '...',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/blog/' + data.datoCmsBlogPage.featured.slug,
	              className: 'has-text-primary has-text-weight-bold'
	            },
	            'read more.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'column is-half' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' + data.datoCmsBlogPage.featured.slug },
	          _react2.default.createElement(
	            _Slide2.default,
	            { right: true, delay: 500, fraction: 0.5 },
	            _react2.default.createElement(_gatsbyImage2.default, { sizes: data.datoCmsBlogPage.featured.image.sizes })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('hr', { className: 'divider' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column ' },
	          data.allDatoCmsBlog.edges.map(function (blog) {
	            return _react2.default.createElement(
	              'article',
	              {
	                className: 'list-article columns is-multiline',
	                key: blog.node.id
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-one-third-desktop is-12-tablet' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/' + blog.node.slug, className: 'image is-4x3' },
	                  _react2.default.createElement(_gatsbyImage2.default, { sizes: blog.node.image.sizes })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-two-thirds-desktop is-12-tablet' },
	                _react2.default.createElement(
	                  'div',
	                  { className: '' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'has-text-primary' },
	                    blog.node.publishDate
	                  ),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/blog/' + blog.node.slug, className: '' },
	                    _react2.default.createElement(
	                      'h2',
	                      { className: 'title is-marginless is-size-3 has-text-dark is-uppercase has-text-weight-bold' },
	                      blog.node.title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'has-text-dark' },
	                    blog.node.excerpt,
	                    '...',
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      {
	                        to: '/blog/' + blog.node.slug,
	                        className: 'has-text-primary has-text-weight-bold'
	                      },
	                      'read more.'
	                    )
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Blog;
	var BlogListQuery = exports.BlogListQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-fe26918dfbdaec076f22.js